<template>
  <div class="search_tag_list">
    <div class="search_tag" :style="searchItemStyle" ref="list">
      <div :style="searchItemInner">
        <div ref="listInner">
          検索条件：
          <template v-for="(item, index) in tag">
            <i-tag :key="index" closable @on-close="deleteSearchItem(item)">
              {{ item.tag }}
            </i-tag>
          </template>
          <i-button
            type="primary"
            size="small"
            ghost
            :disabled="tag.length === 0"
            style="margin-left: 8px;"
            @click="onClickSaveSearch"
          >
            検索条件を保存
          </i-button>
        </div>
      </div>
    </div>
    <i-icon class="search_more" type="ios-arrow-down" size="14" v-on:click="searchMore()" :class="{ open: isOpen }" />
  </div>
</template>

<script>
import { Tag, Icon, Button } from 'view-design'
import SummarySearchText from '@/mixins/summary_search_text'
export default {
  mixins: [SummarySearchText],
  components: {
    'i-tag': Tag,
    'i-icon': Icon,
    'i-button': Button,
  },
  data() {
    return {
      isOpen: true,
      searchItemStyle: {
        maxHeight: 'auto',
      },
      searchItemInner: {
        overflow: 'auto',
        height: 'auto',
      },
      openHeight: null,
    }
  },
  mounted() {
    this.openHeight = this.$refs.listInner.clientHeight
    this.searchItemStyle.minHeight = 30 + 'px'
    this.searchItemStyle.maxHeight = 250 + 'px'
  },
  watch: {
    tag() {
      this.searchItemInner.overflow = scroll
      this.searchItemInner.height = 30 + 'px'
      this.$nextTick(() => {
        this.openHeight = this.$refs.listInner.clientHeight
      })
      this.searchItemInner.overflow = 'auto'
      this.searchItemInner.height = 'auto'
    },
  },
  computed: {
    search: {
      get() {
        return this.$store.getters['SearchProperty/getSearch']
      },
      set(val) {
        this.$store.commit('SearchProperty/setSearch', val)
      },
    },
    tag: {
      get() {
        return this.$store.getters['Tag/getTag']
      },
      set(val) {
        this.$store.commit('Tag/setTag', val)
      },
    },
  },
  methods: {
    // タグ削除時の処理（再検索）
    deleteSearchItem(item) {
      // 検索パラメータを変更
      if (item.type === 'flg') {
        this.search[item.value] = 0
      }
      if (item.type === 'text') {
        this.search[item.value] = ''
      }
      if (item.type === 'checkboxGroup') {
        this.search[item.value] = []
      }
      if (item.type === 'select') {
        this.search[item.value] = null
      }
      if (item.type === 'range') {
        this.search[`${item._value}_from`] = ''
        this.search[`${item._value}_to`] = ''
      }
      // 詳細検索時
      if (item.type === 'line') {
        this.search[`line_${item._value}`] = ''
        this.search[`line_${item._value}_name`] = ''
        this.search[`line_${item._value}_cd_name`] = ''
        this.search[`station_${item._value}`] = ''
        this.search[`station_end_${item._value}`] = ''
      }

      if (item.type === 'shop') {
        this.search[`${item.value}`] = []
      }

      if (item.type === 'freetag_search_word') {
        this.search[`${item.value}`] = ''
        this.search[`freetag_search_type_${item._value}`] = 1
      }

      if (item.type === 'build') {
        this.search.build_y_from = ''
        this.search.build_m_from = ''
        this.search.build_y_to = ''
        this.search.build_m_to = ''
      }

      if (item.type === 'house_plan') {
        this.search.number_of_rooms_from = ''
        this.search.number_of_rooms_to = ''
        this.search.mi_floor_plan_cd = []
      }

      if (item.type === 'area') {
        let addrArr = this.search.addr_cds.split(',')
        let serachaddrArr = _.remove(addrArr, function(value) {
          if (value !== item.value) return value
        })
        this.search.addr_cds = serachaddrArr.join(',')
      }

      // 沿線から探す
      if (item.type === 'railway') {
        let railWayArr = this.search.railway_cds.split(',')
        const railNames = this.search.railway_names
        // 沿線検索の場合
        if (railNames) {
          let railWayNameArr = railNames.split(',')
          const combineArr = {}
          const tagStr = item.tag // ex. 沿線・駅：JR東海道本線
          // キー：沿線名、値：沿線コードのオブジェクトを作成
          for (let i = 0; i < railWayArr.length; i++) {
            combineArr[railWayNameArr[i]] = railWayArr[i]
          }
          let tmpCd = []
          let tmpName = []
          // 押されたタグの沿線名と検索データの沿線名が一致していない場合、沿線コードと沿線名を検索データに追加
          _.forEach(combineArr, (railCd, railName) => {
            const regex = new RegExp(`^沿線・駅：${railName}$`)
            if (!regex.test(tagStr)) {
              tmpCd.push(railCd)
              tmpName.push(railName)
            }
          })
          this.search.railway_cds = tmpCd.join(',')
          this.search.railway_names = tmpName.join(',')
          // 駅検索の場合
        } else {
          // 近コードのみで判定（ユニークの為）
          let serachRailWay = _.remove(railWayArr, function(value) {
            if (value !== item.value) return value
          })
          this.search.railway_cds = serachRailWay.join(',')
        }
      }

      if (item.type === 'summary') {
        const summary = _.reject(this.search.summary, item.value)
        this.search.summary = summary
        this.$store.commit('ConvertSummary/changeSelectSummary', {
          key: item.summary_value,
          value: 0,
        })
        this.summarySearchText(item.value.shop_id)
      }

      this.$emit('search')
    },
    // タグリスト領域 開閉処理
    searchMore() {
      if (this.isOpen) {
        this.searchItemStyle.maxHeight = 30 + 'px'
        this.isOpen = false
      } else {
        this.searchItemStyle.maxHeight = this.openHeight + 'px'
        this.isOpen = true
      }
    },
    // 検索条件を保存ボタン クリック処理
    onClickSaveSearch() {
      const search = {
        search: this.search,
      }
      const tag = this.tag
      const searchSave = {
        modal: true,
        search: search,
        tag: tag,
      }
      this.$store.commit('ModalSearchSave/setModal', searchSave)
    },
  },
}
</script>

<style lang="scss" scoped>
.search_tag_list {
  position: relative;
  padding: 8px;
  margin-bottom: 8px;
  background-color: #fff;
  .search_tag {
    padding-right: 32px;
    display: flex;
    overflow: hidden;
    flex-flow: wrap;
    align-items: center;
    justify-content: flex-start;
    transition: all 0.6s ease;
  }
  .search_more {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
    transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
    &.open {
      transform: rotate(180deg);
    }
  }
  .ivu-tag {
    margin-top: 4px;
    margin-bottom: 4px;
  }
}
</style>

<style lang="scss">
.search_tag_list {
  .ivu-tag {
    &.disabledTag {
      .ivu-icon-ios-close {
        cursor: not-allowed;
      }
    }
  }
}
</style>
